import { G_GRAPH__DRAG_AND_DROP__list_images_external } from '@/pages/page_generation/layouts/nodes/node/fields/image/list_image_asset/_drag_and_drop/G_GRAPH__DRAG_AND_DROP__list_images_external';
import { G_GRAPH__DRAG_AND_DROP__list_images_internal } from '@/pages/page_generation/layouts/nodes/node/fields/image/list_image_asset/_drag_and_drop/G_GRAPH__DRAG_AND_DROP__list_images_internal';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { G_UI_FIELD__image_asset_empty_base } from '../../image_asset/empty/G_UI_FIELD__image_asset_empty_base';
import { G_BUTTON__image_asset_list_upload } from '../_buttons/G_BUTTON__image_asset_list_upload';

interface PROPS {
  field: FIELD__list_image_asset;
}

export function G_UI_FIELD__image_asset_list_empty_image({ field }: PROPS) {
  return (
    <G_UI_FIELD__image_asset_empty_base>
      <>
        <G_BUTTON__image_asset_list_upload {...{ field }} />

        <G_GRAPH__DRAG_AND_DROP__list_images_external {...{ field }} />
        <G_GRAPH__DRAG_AND_DROP__list_images_internal {...{ field }} />
      </>
    </G_UI_FIELD__image_asset_empty_base>
  );
}
